import { getAuthUrl } from "./config-utils";

/** Login page URL that brings the user back to the current page. */
export const loginUrlWithReturn = () => {
  const loginUrl = new URL(getAuthUrl());
  loginUrl.searchParams.set(
    "language",
    localStorage.getItem("language") || "fr"
  );
  loginUrl.searchParams.set(
    "returnUrl",
    window.location.pathname + window.location.search
  );
  return loginUrl.toString();
};
